import React, { useEffect, Suspense, useState } from "react"
import { useInView } from "react-intersection-observer"
import GetWindowSize from "../../hooks/general/GetWindowSize"
import CreateCSFR from "../../hooks/userAuthentication/CreateCSFR"
import HeroSection from "../../components/general/landing-preview/HeroSection"
import Footer from "../../components/navigation/Footer"
import NewsletterPopUp from "../../components/general/landing-preview/NewsletterPopUp"
import axios from "axios"

// Lazy load sections
const SecondSection = React.lazy(() =>
    import("../../components/general/landing-preview/SecondSection")
)
const ThirdSection = React.lazy(() =>
    import("../../components/general/landing-preview/ThirdSection")
)
const FourthSection = React.lazy(() =>
    import("../../components/general/landing-preview/FourthSection")
)

interface CoachData {
  coachId: string;
  fullname: string;
  specialization: string[]; 
}

export default function Landing(){
    const newToken = CreateCSFR({ name: "csrftoken" })
    const currentWindow = GetWindowSize()
    // Intersection Observer hooks for each section
    const [refSecond, inViewSecond] = useInView({ triggerOnce: true })
    const [refThird, inViewThird] = useInView({ triggerOnce: true })
    const [refFourth, inViewFourth] = useInView({ triggerOnce: true })
    const [showNewsletter, setShowNewsletter] = useState<boolean>(false)
    const [coachProfiles, setCoachProfiles] = useState<CoachData[] | null>(null)

    useEffect(() => {
        document.title = "SkillJa | Find Sport Coaches and Instructors"
         // Delay Newsletter Popup
         const timer = setTimeout(() => {
          setShowNewsletter(true)
      }, 2500)

      return () => clearTimeout(timer)
    }, [])
 
    useEffect(()=>{
      axios.get(`${process.env.REACT_APP_SKILLJA_URL}/featured_profiles/`, {
        headers: {
            "X-CSRFToken": newToken,
            "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .then((res) => {
          if (res.data.profiles) {
              setCoachProfiles(res.data.profiles)
          } 
      })
      .catch((error) => {
          // console.error("Error checking authentication", error)
      })
    },[])

    return (
        <>
          {currentWindow.width < 1024 ? (
            <>
              {showNewsletter && <NewsletterPopUp handleExit={setShowNewsletter} />}
              <HeroSection view="mobile" />

              <div className="mt-28 md:mt-0" ref={refSecond}>
                {inViewSecond && (
                  <Suspense fallback={<div className="mx-auto text-center text-sm">Loading...</div>}>
                    {coachProfiles && <SecondSection coachProfileData={coachProfiles} />}
                  </Suspense>
                )}
              </div>

              <div className="mt-32" ref={refFourth}>
                {inViewFourth && (
                  <Suspense fallback={<div className="mx-auto text-center text-sm">Loading...</div>}>
                    <FourthSection />
                  </Suspense>
                )}
              </div>

              <div className="mt-32 mb-12">
                <Footer />
              </div>
            </>
          ) : (
            <>
              <HeroSection view="desktop" />

              {showNewsletter && <NewsletterPopUp handleExit={setShowNewsletter} />}

              <div className="mt-48" ref={refSecond}>
                {inViewSecond && (
                  <Suspense fallback={<div className="mx-auto text-center text-sm">Loading...</div>}>
                    <SecondSection coachProfileData={coachProfiles}/>
                  </Suspense>
                )}
              </div>
    
              <div className="mt-48" ref={refThird}>
                {inViewThird && (
                  <Suspense fallback={<div className="mx-auto text-center text-sm">Loading...</div>}>
                    <ThirdSection />
                  </Suspense>
                )}
              </div>
    
              <div className="mt-48" ref={refFourth}>
                {inViewFourth && (
                  <Suspense fallback={<div className="mx-auto text-center text-sm">Loading...</div>}>
                    <FourthSection />
                  </Suspense>
                )}
              </div>
    
              <div className="mt-48 mb-10">
                <Footer />
              </div>
            </>
          )}
        </>
      )
}

